import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild ,HostListener} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService, EntityPagedResult, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Aviso, TIPOS_AVISO } from 'src/app/model/aviso.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AvisoService } from './aviso.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service'; 
import { ExportService } from '../../shared/services/export.service'; 

@Component({
    selector: 'app-aviso-pesquisa',
    templateUrl: './aviso-pesquisa.component.html',
    standalone: false
})
export class AvisoPesquisaComponent implements OnInit {

  // modelo do formulario
  private pesquisaForm: UntypedFormGroup;
  public pesquisado: boolean = false; // usado no html
  public esconderPesquisa: boolean = true;
  private valoresPesquisaForm: any;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private cnpjUsuario: string;
  public avisos: Aviso[];
  private atributosPaginacaoComponenteListagem: EntityPagedResult<Aviso>;
  private opcoesPaginacao: number[];
  private podeCadastrarAviso: boolean = false;
  private perfilAgente: Boolean = true;
  private tiposAviso = TIPOS_AVISO;
  private avisoDesativando: Aviso;
  //private atualizarBusca: boolean;
  private totalObjetosRetornados: number;

  @ViewChild('desativacao') desativacao: TemplateRef<any>;
  @ViewChild('desativacaoBotoes') desativacaoBotoes: TemplateRef<any>;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private avisoService: AvisoService,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private modalService: BnModalMessageService,
    private messageService: MessageChannelService,
    private modalidadeService: ModalidadeService,
    private exportService: ExportService,
    ) {
      this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
      this.opcoesPaginacao = [10, 15, 20];
      this.atributosPaginacaoComponenteListagem = {
        page: 1,
        pageSize: this.opcoesPaginacao[0],
        pages: undefined,
        count: undefined,
        list: undefined
      };
  }
  
  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent){
    this.buscar(false,true)
  }

  ngOnInit() {
    this.pesquisaForm = this.formBuilder.group({
      agenteFinanceiro: null,
      tipo: null,
      situacao: 'T',
      titulo: null,
      dataCriacaoInicial: null,
      dataCriacaoFinal: null,
      dataDesativacaoInicial: null,
      dataDesativacaoFinal: null,
    });

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario?.cnpj;
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
        this.podeCadastrarAviso = resp && resp[ROLE_GESTOR_ENVIO];
        this.perfilAgente = resp && !(resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
        this.construirFormulario();
        sessionStorage.getItem('avisoPesquisaFiltrado')==='S' && this.buscar(false, false);
      });

    this.modalidadeService.modalidade$.subscribe((modalidade) => {
      let modalidadesHabilitadas = ['FGT', 'FGBS'];
      if (!modalidadesHabilitadas.includes(modalidade)) {
        this.tiposAviso = this.tiposAviso.filter(tipo => tipo.codigo !== 7);
      }
    });  
    
  }

  private construirFormulario() {
    const valoresSessao = sessionStorage.getItem('avisoPesquisaFiltros');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : null;

    var agenteDefault = null;
    if (this.perfilAgente) {
      agenteDefault = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
      this.pesquisaForm.get("agenteFinanceiro").disable();
    }
    if (this.valoresPesquisaForm) {
      if (!agenteDefault && this.valoresPesquisaForm.agenteFinanceiro) {
        agenteDefault = this.agentesFinanceiros.filter(agente => agente.cnpj === this.valoresPesquisaForm.agenteFinanceiro.cnpj)[0];
      };
      this.pesquisaForm.setValue({
        agenteFinanceiro: agenteDefault,
        tipo: this.valoresPesquisaForm.tipo,
        situacao: this.valoresPesquisaForm.situacao,
        titulo: this.valoresPesquisaForm.titulo,
        dataCriacaoInicial: this.valoresPesquisaForm.dataCriacaoInicial? this.valoresPesquisaForm.dataCriacaoInicial : null,
        dataCriacaoFinal: this.valoresPesquisaForm.dataCriacaoFinal? this.valoresPesquisaForm.dataCriacaoFinal : null,
        dataDesativacaoInicial: this.valoresPesquisaForm.dataDesativacaoInicial? this.valoresPesquisaForm.dataDesativacaoInicial: null,
        dataDesativacaoFinal: this.valoresPesquisaForm.dataDesativacaoFinal? this.valoresPesquisaForm.dataDesativacaoFinal : null,
      });
    } else {
      this.pesquisaForm.get("agenteFinanceiro").setValue(agenteDefault);
    };
    //this.pesquisaForm.updateValueAndValidity();
    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('avisoPesquisaFiltros', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<Aviso>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia, voltarPagina1) {
    this.loadingService.bloqueiaTela();
    this.esconderPesquisa = true;

    const dadosPreenchidos = this.tratarInformacoesPreenchidas();

    dadosPreenchidos.pagina = this.atributosPaginacaoComponenteListagem.page;
    dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    this.avisoService.getAvisos(dadosPreenchidos).subscribe(response => {
        this.avisos = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count ;
        this.pesquisado = true;
        this.esconderPesquisa = false;
        sessionStorage.setItem('avisoPesquisaFiltrado', 'S');
        this.loadingService.liberaTela();

        paginaVazia = Utils.verificaPaginaVazia(this.avisos, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }
      });
  }

  limpar() {
    sessionStorage.setItem('avisoPesquisaFiltrado', "N");
    if (this.perfilAgente) {
      this.pesquisaForm.reset({
        situacao: 'T',
        agenteFinanceiro: this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0]
      });
    } else {
      this.pesquisaForm.reset({
        situacao: 'T',
      });
    }
    this.avisos = [];
    this.pesquisado = false;
  }


  desativacaoAviso(aviso: Aviso) {
    this.avisoDesativando = aviso;
    this.avisoDesativando.dataDesativacao = moment().format('YYYY-MM-DDTHH:mm:ss');
    this.modalService
      .abrir('Desativação de Aviso', null, 'lg', this.desativacao, this.desativacaoBotoes).result
      .then((avisoDesativado) => {
            this.messageService.addMessage({
                title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Aviso desativado com sucesso.'
            });
            this.buscar(false, true);
        }, (reason) => {
          console.log(reason);
        }
      );
  }

  confirmaDesativacao() {
    this.loadingService.bloqueiaTela();
    this.avisoService.desativa(this.avisoDesativando.id)
        .subscribe(avisoDesativado => {
            this.modalService.close(avisoDesativado);
            this.loadingService.liberaTela();
        }, error => {
            console.log(error);
            this.loadingService.liberaTela();
        });
  }

  cancelaDesativacao() {
    this.modalService.dismiss("abortou desativação");
  }

  compararPorId(item1: string, item2: string): boolean {
    return Utils.compararPorId(item1, item2);
  }

  public nomeAgente(id: number) {
    return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
  }

  tratarInformacoesPreenchidas() {
    const params: any = {};

    const agenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;
    if (agenteFinanceiro) {
        params.idAgenteFinanceiro = agenteFinanceiro.id;
    }

    const tipo = this.pesquisaForm.get('tipo').value
    if (tipo) {
      params.tipo = tipo;
    }

    const dataCriacaoInicial = this.pesquisaForm.get('dataCriacaoInicial').value;
    if (dataCriacaoInicial) {
      params.dataCriacaoInicial = this.datePipe.transform(dataCriacaoInicial, 'yyyyMMdd');
    }

    const dataCriacaoFinal = this.pesquisaForm.get('dataCriacaoFinal').value;
    if (dataCriacaoFinal) {
      params.dataCriacaoFinal = this.datePipe.transform(dataCriacaoFinal, 'yyyyMMdd');
    }

    const dataDesativacaoInicial = this.pesquisaForm.get('dataDesativacaoInicial').value;
    if (dataDesativacaoInicial) {
      params.dataDesativacaoInicial = this.datePipe.transform(dataDesativacaoInicial, 'yyyyMMdd');
    }

    const dataDesativacaoFinal = this.pesquisaForm.get('dataDesativacaoFinal').value;
    if (dataDesativacaoFinal) {
      params.dataDesativacaoFinal = this.datePipe.transform(dataDesativacaoFinal, 'yyyyMMdd');
    }

    const titulo = this.pesquisaForm.get('titulo').value;
    if (titulo) {
      params.titulo = titulo.trim();
    }

    if (this.perfilAgente) {
      params.situacao = 'A';
    } else {
      params.situacao = this.pesquisaForm.get('situacao').value;
    }

    return params;
  }

  exportarAvisos() {
    this.loadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    this.avisoService.getAvisos(dadosPreenchidos).subscribe((resp) => {
      this.exportService.exportarListaAvisos(resp);
    });
  }

}
